const API_BASE_URL = "https://api.tsg-ai.com";

export default API_BASE_URL;